import { Helmet } from "react-helmet-async";

const SITE = typeof window !== "undefined" ? window.location.origin : "";
const DEFAULT_IMAGE =
  `${typeof window !== "undefined" ? window.location.origin : "https://collabnexus.co.uk"}/nexus-logo.png`;
const DEFAULT_KEYWORDS = [
  "influencer marketplace",
  "hire influencers",
  "creator marketplace",
  "brand collabs",
  "UGC creator platform",
  "escrow influencer marketing",
  "sponsored content platform",
  "verified creators",
  "influencer campaigns",
  "content creator hire",
];

export default function SEO({
  title,
  description,
  keywords = [],
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} · Nexus` : "Nexus — Hire Vetted Social Media Creators";
  const desc =
    description ||
    "The escrow-protected marketplace where brands hire vetted social media creators. Fund, deliver, approve, get paid.";
  const kw = [...new Set([...DEFAULT_KEYWORDS, ...keywords])].join(", ");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Nexus" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
